module.exports = __webpack_public_path__ + "img/cooperate_16.79c3a82a.png";